/** * 哈希表 */
class HashMap {
  constructor() {
    this.length = 0
    this.obj = new Object()
  }
  /**     * 是否为空     */
  isEmpty() {
    return length == 0
  }
  /**     * 判断对象中是否包含给定key     */
  containsKey(key_) {
    return key_ in this.obj
  }
  /**     * 判断对象中是否包含给定的Value     */
  containsValue(value) {
    for (var key_ in this.obj) {
      if (this.obj[key_] == value) {
        return true
      }
    }
    return false
  }
  /**     * 向map中添加数据     */
  put(key, value) {
    if (!this.containsKey(key)) {
      this.length++
    }
    this.obj[key] = value
  }
  /**     * 根据给定的Key获得Value     */
  get(key) {
    return this.containsKey(key) ? this.obj[key] : null
  }
  /**     * 根据给定的Key删除一个值     */
  remove(key) {
    if (this.containsKey(key) && delete this.obj[key]) {
      this.length--
    }
  }
  /**     * 获得Map中的所有Value     */
  values() {
    var _values = new Array()
    for (var key in this.obj) {
      _values.push(this.obj[key])
    }
    return _values
  }
  /**     * 获得Map中的所有Key     */
  keySet() {
    var _keys = new Array()
    for (var key in this.obj) {
      _keys.push(key)
    }
    return _keys
  }
  /**     * 获得Map的长度     */
  size() {
    return this.length
  }
  /**
   * 清空Map
   */
  clear() {
    this.length = 0
    this.obj = new Object()
  }
}
export { HashMap }
// # sourceMappingURL=HashMap.js.map



// WEBPACK FOOTER //
// ./src/ts/core/HashMap.js